(() => {
  const ROOT_SELECTOR = '[data-terms-root]';

  const setStatus = (link, text) => {
    const original = link.textContent;
    link.textContent = text;

    window.setTimeout(() => {
      link.textContent = original;
    }, 1800);
  };

  const copySectionLink = async (link) => {
    const url = new URL(link.getAttribute('href'), window.location.href).href;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        setStatus(link, 'Link skopiowany');
        return;
      }
    } catch (error) {
      console.error('Terms link copy error:', error);
    }

    window.location.hash = link.getAttribute('href');
  };

  const createPrintDocument = (root) => {
    const clone = root.cloneNode(true);

    clone.querySelectorAll([
      '.pf-terms__hero-actions',
      '.pf-terms__facts',
      '.pf-terms__section-link',
      '.pf-terms__online-return-actions',
      '.pf-terms__footer',
      '[data-terms-print]'
    ].join(',')).forEach((element) => element.remove());

    clone.querySelectorAll('*').forEach((element) => {
      element.removeAttribute('style');
    });

    const title =
      root.querySelector('h1')?.textContent.trim() ||
      document.title ||
      'Regulamin sklepu';

    return {
      title,
      html: clone.outerHTML
    };
  };

  const openPrintView = (root) => {
    const printView = createPrintDocument(root);
    const frame = document.createElement('iframe');

    frame.setAttribute('title', 'Wersja regulaminu do druku');
    frame.setAttribute('aria-hidden', 'true');
    frame.style.position = 'fixed';
    frame.style.left = '-10000px';
    frame.style.top = '0';
    frame.style.width = '1px';
    frame.style.height = '1px';
    frame.style.border = '0';
    frame.style.opacity = '0';
    frame.style.pointerEvents = 'none';

    document.body.appendChild(frame);

    const frameWindow = frame.contentWindow;
    const frameDocument = frame.contentDocument || frameWindow?.document;

    if (!frameWindow || !frameDocument) {
      frame.remove();
      window.print();
      return;
    }

    let cleaned = false;

    const cleanup = () => {
      if (cleaned) return;
      cleaned = true;
      window.setTimeout(() => frame.remove(), 50);
    };

    frameWindow.addEventListener('afterprint', cleanup, { once: true });

    frameDocument.open();
    frameDocument.write(`<!doctype html>
<html lang="pl">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <title>${printView.title.replace(/[<>&"]/g, '')}</title>
  <style>
    @page {
      size: A4;
      margin: 15mm 14mm 16mm;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
      color: #111 !important;
      background: #fff !important;
      background-image: none !important;
      box-shadow: none !important;
      text-shadow: none !important;
      filter: none !important;
      -webkit-text-fill-color: #111 !important;
    }

    html,
    body {
      margin: 0;
      padding: 0;
      color: #111 !important;
      background: #fff !important;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 10.5pt;
      line-height: 1.48;
      -webkit-print-color-adjust: economy;
      print-color-adjust: economy;
    }

    .pf-terms {
      width: 100%;
      color: #111 !important;
      background: #fff !important;
    }

    .page-width,
    .pf-terms__hero-inner,
    .pf-terms__layout,
    .pf-terms__content {
      width: 100%;
      max-width: none;
      margin: 0;
      padding-left: 0;
      padding-right: 0;
    }

    .pf-terms__hero {
      margin: 0 0 6mm;
      padding: 0 0 6mm;
      border-bottom: 1px solid #999;
    }

    .pf-terms__hero-inner {
      display: block;
      padding-top: 0;
      padding-bottom: 0;
    }

    .pf-terms__eyebrow {
      margin: 0 0 2mm;
      font-size: 9pt;
      font-weight: 700;
      letter-spacing: .08em;
      text-transform: uppercase;
    }

    .pf-terms h1 {
      margin: 0 0 3mm;
      font-size: 23pt;
      line-height: 1.1;
    }

    .pf-terms__lead,
    .pf-terms__lead p {
      margin: 0;
      font-size: 11pt;
    }

    .pf-terms__version-bar {
      display: block;
      margin: 0 0 7mm;
      padding: 0 0 5mm;
      border-bottom: 1px solid #aaa;
    }

    .pf-terms__version-bar p {
      margin: 0 0 1.5mm;
      font-size: 9.5pt;
    }

    .pf-terms__toc,
    .pf-terms__section {
      margin: 0 0 6mm;
      padding: 5.5mm;
      border: 1px solid #aaa;
      border-radius: 0;
    }

    .pf-terms__toc {
      break-after: page;
      page-break-after: always;
    }

    .pf-terms__toc-title {
      margin: 0 0 3mm;
      font-size: 15pt;
    }

    .pf-terms__toc ul {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5mm 6mm;
      margin: 0;
      padding-left: 5mm;
    }

    .pf-terms__toc li {
      margin: 0;
    }

    .pf-terms__section {
      break-inside: auto;
      page-break-inside: auto;
    }

    .pf-terms__section h2 {
      margin: 0 0 4mm;
      font-size: 16pt;
      line-height: 1.2;
      break-after: avoid;
      page-break-after: avoid;
    }

    .pf-terms__section h3 {
      margin: 5mm 0 2.5mm;
      font-size: 12.5pt;
      break-after: avoid;
      page-break-after: avoid;
    }

    .pf-terms__section p {
      margin: 0 0 3mm;
      orphans: 3;
      widows: 3;
    }

    .pf-terms__section ol,
    .pf-terms__section ul {
      margin-top: 0;
      padding-left: 7mm;
    }

    .pf-terms__section li {
      margin-bottom: 2.8mm;
      orphans: 3;
      widows: 3;
    }

    .pf-terms__info-box,
    .pf-terms__online-return {
      margin: 4mm 0;
      padding: 4mm;
      border: 1px solid #999;
      border-radius: 0;
    }

    .pf-terms a {
      color: #111 !important;
      text-decoration: underline;
      overflow-wrap: anywhere;
    }

    .pf-terms a[href^="http"]::after,
    .pf-terms a[href^="/"]::after {
      content: " (" attr(href) ")";
      font-size: 8pt;
      font-weight: 400;
      text-decoration: none;
    }
  </style>
</head>
<body>
  ${printView.html}
</body>
</html>`);
    frameDocument.close();

    const triggerPrint = () => {
      try {
        frameWindow.focus();
        frameWindow.print();
      } catch (error) {
        console.error('Terms print error:', error);
        cleanup();
        window.print();
      }
    };

    if (frameDocument.readyState === 'complete') {
      window.setTimeout(triggerPrint, 250);
    } else {
      frame.addEventListener('load', () => {
        window.setTimeout(triggerPrint, 250);
      }, { once: true });
    }

    window.setTimeout(cleanup, 120000);
  };

  const init = (root) => {
    if (!root || root.dataset.termsInitialized === 'true') return;

    root.querySelector('[data-terms-print]')?.addEventListener('click', () => {
      openPrintView(root);
    });

    root.querySelectorAll('[data-terms-section-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        copySectionLink(link);
      });
    });

    root.dataset.termsInitialized = 'true';
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector(ROOT_SELECTOR));
  });
})();
